<template>
<div class="chapter">
<div class="inner_page">
<p class="dedi"><a id="page_v"></a><em>For George Athan Billias</em>,<br/><em>who represents what the profession</em><br/><em>is supposed to be about.</em> <a id="page_vi"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedi.vue?12dca817